import { apiClient } from '@/shared/api';
import type {
  GetWithdrawDataRequest,
  WithdrawBankTransferBodyRequest,
  WithdrawBankTransferRequestFunction,
  WithdrawParamsResponse,
} from '@/features/withdraw-bank-transfer';
import type { WithdrawSuccessResponse } from '@/shared/types';
import { createWithdrawOperation } from '@/entities/operation';

export const getFormParams = async (
  templateId?: string
): Promise<WithdrawParamsResponse> => {
  const response = await apiClient.get<WithdrawParamsResponse>(
    `/operations/bank/withdraw/params`,
    {
      params: { templateId },
    }
  );
  return response.data;
};

export const exchangeWithdrawFormParams = async (
  requestBody: GetWithdrawDataRequest
): Promise<WithdrawParamsResponse> => {
  const response = await apiClient.post<WithdrawParamsResponse>(
    `/operations/bank/withdraw/params`,
    requestBody
  );
  return response.data;
};

export const withdrawBankTransfer: WithdrawBankTransferRequestFunction =
  async body => {
    return await createWithdrawOperation<
      WithdrawSuccessResponse,
      WithdrawBankTransferBodyRequest
    >('bank', body);
  };
